(function () {
    'use strict';

    function workflowPhaseConfiguration($http, $compile) {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/workflowPhaseConfiguration.html',
            //scope: {
            //    Phase: '=phase',
            //    itemOperationsTarget: '='
            //},
            link: function (scope, element, attrs) {
                //$compile(element)(scope);
            }
        };
    }

    workflowPhaseConfiguration.$inject = ['$http', '$compile'];

    angular.module('ecap.siteConfiguration').directive('workflowPhaseConfiguration', workflowPhaseConfiguration);
})();